












































/* Created- 31 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import ParticaUIBase from "@/Ui-Components/Base/ParticaUIBase.vue";
import { ParticaItem, ParticaSubItem, ParticaDropEvent, eParticaDragType } from "../../../Models/ParticaItem";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";

@Component(
	{
		name: "ParticaTree",
		components: {
			ParticaCard
		}
	})
export default class ParticaTree extends ParticaUIBase {
	@Prop({}) private data: ParticaItem[];
	@Prop({ default: "" }) private title: string;
	@Prop({ default: "" }) private subtitle: string;
	@Prop({ default: false }) private parentdraggable: boolean;
	@Prop({ default: false }) private childdraggable: boolean;
	@Prop({ default: "folder" }) private parenticon: boolean;
	@Prop({ default: "art_track" }) private childicon: boolean;
	private search: string = "";

	private select(item: ParticaSubItem) {
		this.$emit("partica-event", { action: eParticaAction.LEFT_MOUSE_CLICK, item } as ParticaEvent);
	}
	private dragover(e: any) {
		e.dataTransfer.dropEffect = "move";
	}
	private dragstartchild(item: ParticaSubItem, e: any) {
		const dragdata: ParticaDropEvent = { dragtype: eParticaDragType.one, source: item } as ParticaDropEvent;
		e.dataTransfer.setData("application/json", JSON.stringify(dragdata));
	}
	private dragstartparent(item: ParticaItem, e: any) {
		const dragdata: ParticaDropEvent = { dragtype: eParticaDragType.many, source: item } as ParticaDropEvent;
		e.dataTransfer.setData("application/json", JSON.stringify(dragdata));
	}
	private drop(destination: ParticaItem, e: any) {
		const dropped: ParticaDropEvent = JSON.parse(e.dataTransfer.getData("application/json")) as ParticaDropEvent;
		dropped.destination = destination;
		if (dropped.source.parentid === dropped.destination.id) { // dropping on current parent.
			return;
		}
		const pevent: ParticaEvent = { action: eParticaAction.DRAG_MOVE_REQUEST, item: dropped } as ParticaEvent;
		this.$emit("partica-event", pevent);
	}
	private rightClick(article: ParticaSubItem) {
		this.$emit("partica-event", { action: eParticaAction.RIGHT_MOUSE_CLICK, item: article } as ParticaEvent);
	}
}
